import { getDisplayText, type IncomeRecord } from "@aera/data-table";

const INCOME_SOURCE_CHANNEL_LABELS: Record<string, string> = {
  line_oa: "LINE OA",
  line: "LINE OA",
  web: "เว็บ",
  ocr: "OCR",
  capture: "รับสลิป",
  system: "สลิปจาก ระบบ",
};

function readRecordField(record: IncomeRecord, ...keys: string[]): string {
  const raw = record as Record<string, unknown>;
  for (const key of keys) {
    const value = getDisplayText(raw[key]).trim();
    if (value) return value;
  }
  return "";
}

function paymentSourceFromChannel(
  channelKey: string,
  partyName: string,
  sourceExtra = "",
): string {
  const party = partyName.trim();
  const extra = sourceExtra.trim();
  switch (channelKey) {
    case "line_oa":
    case "line":
      return party ? `สลิปจาก LINE · ${party}` : "สลิปจาก LINE";
    case "web":
      return party ? `สลิปจากเว็บ · ${party}` : "เว็บ";
    case "ocr":
      return party ? `OCR · ${party}` : "OCR";
    case "capture":
      return party ? `รับสลิป · ${party}` : "รับสลิป";
    case "system":
      return extra || "สลิปจาก ระบบ";
    default:
      return extra;
  }
}

/** Mirror billlin-agent evidence._source_label + feed.source_label for รายรับ rows. */
export function incomeRecordSourceLabel(record: IncomeRecord): string {
  const explicit = readRecordField(record, "source_label", "sourceLabel");
  if (explicit) return explicit;

  const party = readRecordField(record, "party_name", "sender_name");
  const sourceExtra = readRecordField(record, "source_extra");

  const ingress = readRecordField(record, "ingress_channel").toLowerCase();
  if (ingress) {
    if (ingress in INCOME_SOURCE_CHANNEL_LABELS) {
      return (
        paymentSourceFromChannel(ingress, party, sourceExtra) ||
        INCOME_SOURCE_CHANNEL_LABELS[ingress]!
      );
    }
    return "";
  }

  const channel = readRecordField(record, "channel").toLowerCase();
  if (channel) {
    if (channel in INCOME_SOURCE_CHANNEL_LABELS) {
      return (
        paymentSourceFromChannel(channel, party, sourceExtra) ||
        INCOME_SOURCE_CHANNEL_LABELS[channel]!
      );
    }
    return "";
  }

  const userId = readRecordField(record, "user_id", "income_user_id");
  if (userId.startsWith("line_")) {
    return party ? `สลิปจาก LINE · ${party}` : "LINE OA";
  }

  if (String(record.image_url ?? "").trim()) {
    return party ? `สลิปจาก LINE · ${party}` : "สลิปจาก LINE";
  }

  if (sourceExtra) return sourceExtra;
  if (party) return `สลิปจาก LINE · ${party}`;
  return "รายการธนาคาร · ยังไม่ทราบผู้โอน";
}

export { closedProvenanceSourceLabel } from "./incomeRecordQueueDisplay";
